import Modal from '@mos-cat/modal';
import React, { useEffect, FC } from 'react';
import { connect } from 'react-redux';

import ServicesCatalog from '@components/ServicesCatalog';

import st from './CatalogModal.module.css';

type CatalogModalProps = {
  visible: boolean;
  onClose: (arg?: boolean) => any;
};

const CatalogModal: FC<CatalogModalProps> = ({ visible, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [visible]);

  const onModalClose = () => onClose(false);

  return (
    <Modal
      className={st.modal}
      visible={visible}
      onClose={onModalClose}
      headerContent={<div className={st.title}>Каталог услуг МФЦ</div>}
    >
      {visible && (
        <div className={st.catalogWrapper}>
          {/* @ts-ignore */}
          <ServicesCatalog onClose={onClose} />
        </div>
      )}
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  mobileMapOpened: state.ui && state.ui.mobileMapOpened,
  legendOpened: state.ui && state.ui.legendOpened,
  officeId: state.mfc && state.mfc.id,
});

export default connect(mapStateToProps, {})(CatalogModal);
